<template>
  <el-dialog
          title="流水概览详情"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          @opened="dialogOpen"
  >
    <div class="header" flex="main:justify cross:center">
      <el-form
              :inline="true"
              :model="searchForm"
              ref="searchForm"
              size="mini"
              style="margin-bottom: -18px;"
      >

        <el-form-item
        >
          <el-date-picker
                  v-model="pickerValue"
                  type="daterange"
                  align="right"
                  size="small"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 300px;"
                  value-format="yyyy-MM-dd" format="yyyy-MM-dd">
            ></el-date-picker>
        </el-form-item>

        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pay_type"
                  placeholder="支付方式"
                  style="width: 100px;"
          >
            <el-option
                    v-for="item in bsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pay_state"
                  placeholder="支付状态"
                  style="width: 100px;"
          >
            <el-option
                    v-for="item in ztOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>



        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="header2" flex="main:justify cross:center">
      订单总数 {{order_num}}笔； 订单总金额 {{order_amount}}元； 退款总金额 {{refund_amount}}元； 顾客实付 {{payment_amount}}元； 红包券抵扣 {{discount_amount}}元
    </div>
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.mer_order_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="微信支付订单号"
      >
        <template slot-scope="scope">
          {{scope.row.pay_id}}
        </template>
      </el-table-column>

      <el-table-column
              label="商户名称"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>
      <el-table-column
              label="订单金额"
      >
        <template slot-scope="scope">
          {{scope.row.order_amt_total}}
        </template>
      </el-table-column>
      <el-table-column
              label="创建时间"
      >
        <template slot-scope="scope">
          {{scope.row.order_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.return_code=='0000'">
            <div v-if="scope.row.refund_no!=''">
              全额退款成功
            </div>
            <div v-else> 成功</div>
          </div>
          <div v-else> 未支付</div>
        </template>
      </el-table-column>

      <el-table-column
              label="支付方式"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.refund_no!=''">
            退款
          </div>
          <div v-else>
            <div v-if="scope.row.pay_type=='微信刷脸'">
              微信
            </div>
            <div v-else-if="scope.row.pay_type=='支付宝刷脸'">
              支付宝
            </div>
            <div v-else-if="scope.row.pay_type=='银行卡'">
              银行卡
            </div>
            <div v-else-if="scope.row.pay_type=='会员卡'">
              会员卡
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="支付通道"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          官方
        </template>
      </el-table-column>
      <el-table-column
              label="顾客实付"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.order_amt}}
        </template>
      </el-table-column>
      <el-table-column
              label="红包券抵扣"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.reduce_cost}}
        </template>
      </el-table-column>
      <el-table-column
              label="分账状态"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.return_code=='0000'">
            <div v-if="scope.row.wxfz_state=='0000'">
              成功
            </div>
            <div v-else-if="scope.row.wxfz_state==''">
              无需分账
            </div>
            <div v-else-if="scope.row.wxfz_state=='00000'">
              无需分账
            </div>
            <div v-else> 失败（{{scope.row.wxfz_msg}}）</div>
          </div>
        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:90%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    export default {
        name: "threeagentEditForm",
        props: {
            agent: Object,
            pickerValue2: String,
            pickerValue3: String,
            value: Boolean
        },
        data() {
            return {
                order_amount:'0',
                order_num:'0',
                refund_amount:'0',
                payment_amount:'0',
                discount_amount:'0',
                loading: false,
                dialogVisible: false,
                tableData: [],
                pickerValue: [],

                ztOptions: [
                    {
                        value: "0000",
                        label: "支付成功"
                    },
                    {
                        value: "0001",
                        label: "未支付"
                    },
                    {
                        value: "0002",
                        label: "全额退款成功"
                    }
                ],
                bsOptions: [
                    {
                        value: "支付宝刷脸",
                        label: "支付宝"
                    },
                    {
                        value: "微信刷脸",
                        label: "微信"
                    },
                    {
                        value: "银行卡",
                        label: "银行卡"
                    },
                    {
                        value: "会员卡",
                        label: "会员卡"
                    }
                ],
                searchForm: {
                    pay_type:"",
                    pay_state:""
                },
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dateConversion(value){
                var d = new Date(value);
                //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                console.info("===========date========="+date);
                return date;
            },
            dialogOpen() {
                this.$refs.searchForm.resetFields();
                this.pickerValue=[this.pickerValue2,this.pickerValue3];
                this.getTableData33();
                this.getTableDataMx();

            },
            getTableDataMx() {
                var formData4 = new FormData() // 声明一个FormData对象
                formData4.append("parent_agentid",this.agent.zfb_num);
                formData4.append("memo","1");
                formData4.append("tac_state",this.agent.js_state);
                formData4.append("start_time", this.dateConversion(this.pickerValue[0]));
                formData4.append("end_time", this.dateConversion(this.pickerValue[1]));
                console.info("pay_type======"+this.searchForm.pay_type);
                formData4.append("pay_type",this.searchForm.pay_type);
                formData4.append("pay_state",this.searchForm.pay_state);
                agentService.getStatisticsListJymx(formData4).then(data => {
                    if(data!=null && data!=""){
                        this.order_amount=data.order_amount;
                        this.order_num=data.order_num;
                        this.refund_amount=data.refund_amount;
                        this.payment_amount=data.payment_amount;
                        this.discount_amount=data.discount_amount;


                    }
                });

                //

            },
            getTableData33() {
                console.info("===========ddddddddd========="+this.pickerValue[0]);
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    parent_agentid: this.agent.zfb_num,
                    tac_state: this.agent.js_state,
                    start_time:this.pickerValue[0],
                    end_time:this.pickerValue[1],
                    memo:"1",
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getMobileOrderPagelistJymxBt(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                });
            },
            handleSearchFormSubmit() {
                this.getTableData33();
                this.getTableDataMx();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData33();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData33();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData33();
            },
            close() {
                this.$refs["searchForm"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>
<style lang="scss" scoped>
  .header {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
